import { html, render } from "lit-html";
import { connect } from "../connect-with-dialog";
import { translate } from "@escapio/shared/l10n/translate";
import { DirectContactDialog } from "./DirectContactDialog";

customElements.define(
	"esc-profile-direct-contact-box",
	connect(
		DirectContactDialog,
		class extends HTMLElement {
			connectedCallback() {
				render(
					html`<div class="direct-contact-box">
						<div class="direct-contact-box__text">
							<div class="direct-contact-box__header">
								${translate("hotel_direct_contact_request_offer")}
							</div>
							<i class="fa fa-envelope direct-contact-box__icon"></i>
							${translate("hotel_direct_contact_features")}
						</div>
						<button
							type="button"
							class="secondary-button direct-contact-box__cta"
						>
							${translate("hotel_direct_contact_open_form")}
						</button>
					</div>`,
					this,
				);
			}
		},
	),
);
